module.exports = "/_next/static/images/0fa7c3d69bf7c3a3e69c0287ec8d9ce2-defer-lg.png.webp";